import { create } from 'zustand';

export const useEmailCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  openEmailCreate: (payload) => set({ isOpen: true, payload }),
  close: () => set({ isOpen: false, payload: {} })
}));
export const openEmailCreate = (payload) => {
  const store = useEmailCreateStore.getState();
  store.openEmailCreate(payload);
};

export const closeEmailCreate = () => {
    console.log("closed called");
  const store = useEmailCreateStore.getState();
  store.close();
};